const isInnerProject = ({ id = '' }: { id: string }): boolean => {
  return id?.includes?.('profile');
};

export default isInnerProject;
